import { request } from '../boot/request';

const getOrderHistory = params => {
  params = params || {};
  return request({
    url: '/orderHistory',
    method: 'POST',
    data: params,
  });
};

const setSessionCollectionMethod = params => {
  params = params || {};
  return request({
    url: '/setSessionServiceType',
    method: 'POST',
    data: params,
  });
};

export { getOrderHistory, setSessionCollectionMethod };
